import React from "react";
import { Form } from "antd";
import { toFixedWithoutRounding } from "../utils/math";
import moment from "moment-timezone";

const SingleCycleForm = ({ children, form, isClickedEditingAll, ...props }) => {
  const calculateUnitCost = (totalAmount, quantity) =>
    quantity > 0 ? toFixedWithoutRounding(totalAmount / quantity, 2) : "";

  const calculateTotalAmount = (quantity, unitCost) =>
    quantity >= 0 && unitCost >= 0 ? toFixedWithoutRounding(quantity * unitCost, 2) : "";

  const updateFormValues = (changedValues, calculateFn) => {
    const currentValues = form.getFieldsValue();
    const updatedValues = { ...currentValues };

    Object.entries(changedValues).forEach(([index]) => {
      updatedValues[index] = {
        ...updatedValues[index],
        ...calculateFn(updatedValues[index])
      };
    });

    form.setFieldsValue(updatedValues);
  };

  const handleUnitCostUpdate = (changedValues) => {
    if (isClickedEditingAll) {
      updateFormValues(changedValues, ({ totalAmount, quantity }) => ({
        unitCost: calculateUnitCost(totalAmount, quantity)
      }));
    } else {
      const { totalAmount, quantity } = form.getFieldsValue(["totalAmount", "quantity"]);
      const unitCost = calculateUnitCost(totalAmount, quantity);
      form.setFieldsValue({ totalAmount, quantity, unitCost });
    }
  };

  const handleTotalAmountUpdate = (changedValues) => {
    if (isClickedEditingAll) {
      updateFormValues(changedValues, ({ quantity, unitCost }) => ({
        totalAmount: calculateTotalAmount(quantity, unitCost)
      }));
    } else {
      const { quantity, unitCost } = form.getFieldsValue(["quantity", "unitCost"]);
      const totalAmount = calculateTotalAmount(quantity, unitCost);
      form.setFieldsValue({ quantity, unitCost, totalAmount });
    }
  };

  const handleBillVoidedDateUpdate = (changedValues) => {
    if (isClickedEditingAll) {
      updateFormValues(changedValues, ({ billVoidedDate }) => ({
        billVoided: billVoidedDate ? true : false,
        billVoidedDate
      }));
    } else {
      const { billVoidedDate } = form.getFieldsValue(["billVoidedDate"]);
      form.setFieldsValue({
        billVoidedDate,
        billVoided: billVoidedDate ? true : false
      });
    }
  };

  const handleBillVoidedUpdate = (changedValues) => {
    if (isClickedEditingAll) {
      updateFormValues(changedValues, ({ billVoided }) => ({
        billVoided: billVoided ? true : false,
        billVoidedDate: billVoided ? moment() : null
      }));
    } else {
      const { billVoided } = form.getFieldsValue(["billVoided"]);
      form.setFieldsValue({
        billVoidedDate: billVoided ? moment() : null,
        billVoided: billVoided ? true : false
      });
    }
  };

  const onValuesChange = (changedValues) => {
    const changedKeys = Object.keys(isClickedEditingAll ? Object.values(changedValues)[0] : changedValues);

    const fieldName = changedKeys.find((key) =>
      ["totalAmount", "quantity", "unitCost", "billVoidedDate", "billVoided"].includes(key)
    );

    switch (fieldName) {
      case "totalAmount":
        handleUnitCostUpdate(changedValues);
        break;
      case "quantity":
      case "unitCost":
        handleTotalAmountUpdate(changedValues);
        break;
      case "billVoidedDate":
        handleBillVoidedDateUpdate(changedValues);
        break;
      case "billVoided":
        handleBillVoidedUpdate(changedValues);
        break;
      default:
        break;
    }
  };

  return (
    <Form form={form} onValuesChange={onValuesChange} {...props}>
      {children}
    </Form>
  );
};

export { SingleCycleForm };
